module.exports = __webpack_public_path__ + "static/media/shift_login.c16c9b26.png";